import { render, staticRenderFns } from "./gamePayConfig.vue?vue&type=template&id=c74ad580&"
import script from "./gamePayConfig.vue?vue&type=script&lang=js&"
export * from "./gamePayConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c74ad580')) {
      api.createRecord('c74ad580', component.options)
    } else {
      api.reload('c74ad580', component.options)
    }
    module.hot.accept("./gamePayConfig.vue?vue&type=template&id=c74ad580&", function () {
      api.rerender('c74ad580', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpGameManager/gamePayConfig.vue"
export default component.exports